/**
 * ランダムに仮のIDを作成します。
 *
 * @param {string|boolean} [prefix='id-'] - 生成されるIDの接頭辞。falseを指定すると、接頭辞なしでIDが返されます。
 * @returns {string}
 */
export function temporaryId(prefix = 'id-') {
    if (prefix === false) {
        prefix = '';
    }
    return prefix + Math.floor(Math.random() * 10000000000000000).toString(36);
}
